/**
 * Get the full API URL with /api prefix
 * @param {string} path - API path (e.g., "/models", "/skills")
 * @returns {string} Full API URL
 */

import { OPEN_CLAW_BASE_URL } from './index';
import { LOCAL_STORAGE_KEY } from '@/constants';
import { getStorageAuthInfo } from '@/utils/storageOperateApi';

export function getApiUrl(path) {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${OPEN_CLAW_BASE_URL}/api/copaw${normalizedPath}`;
}

/**
 * Get the API token
 * @returns {string} API token string or empty string
 */
export function getApiAuthInfo() {
  const userInfo = getStorageAuthInfo(LOCAL_STORAGE_KEY.JM_AUTH_INFO);
  return { token: userInfo.webtoken, uid: userInfo.uid };
}
